import WarningSVG from "../../content/img/warning.svg";
import { useTranslation } from "react-i18next";
import { Button } from "@etframework/ui.components";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const { t } = useTranslation(["errorPages"]);
  const navigate = useNavigate();

  return (
    <>
      <div className="error-page-container">
        <img
          src={WarningSVG}
          alt="Error illustration"
          className="error-image unauthorized"
        />
        <h1 className="error-title">{t("NotFound.title")}</h1>
        <p className="error-message">{t("NotFound.message")}</p>
        <div className="mt-4">
          <Button onClick={() => navigate("/")}>{t("HomeBtn")}</Button>
        </div>
      </div>
    </>
  );
};
